"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useComponentSize = void 0;
const react_1 = require("react");
const useComponentSize = () => {
    const ref = (0, react_1.useRef)(null);
    const [size, setSize] = (0, react_1.useState)({ width: 0, height: 0 });
    (0, react_1.useEffect)(() => {
        const handleResize = () => {
            if (ref.current) {
                setSize({
                    width: ref.current.offsetWidth,
                    height: ref.current.offsetHeight,
                });
            }
        };
        handleResize(); // Set initial size
        // Setup resize observer for more fluid UI updates
        const resizeObserver = new ResizeObserver(handleResize);
        if (ref.current) {
            resizeObserver.observe(ref.current);
        }
        // Cleanup observer on component unmount
        return () => {
            if (ref.current) {
                resizeObserver.disconnect();
            }
        };
    }, []);
    return [ref, size];
};
exports.useComponentSize = useComponentSize;
